module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('main', [_c('div', {
    staticClass: "left-panel"
  }, [_c('sound-selector')], 1), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('chord-selector')], 1)]), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "key-holder"
  }, [_c('keyboard')], 1), _vm._v(" "), _c('ads-container'), _vm._v(" "), _c('social-footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-654af1ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plypp.vue
// module id = 113
// module chunks = 2